import env from "react-dotenv";
import { ServiceCommon } from "./service.common";
import { isEmpty } from "../utilities/validators";
import { TFilter } from "../types/FilterType";
import { TPagination } from "../types/PaginationType";

class DlvService extends ServiceCommon {
    
    API_DLV = env.API_DLV;

    constructor() {
        super('DlvService');
    }

    /* DELIVER */

    async deliverById(deliverId: number) {
        const url = `${this.API_DLV}/deliver/${deliverId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // deliverById

    async deliverList(attributes: string[], pagination?: TPagination) {
        const url = `${this.API_DLV}/deliver/list`;

        try {
            const resultObject = await this.postReturnObject(url, { attributes, pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // deliverList

    async deliverSearch(filter?: TFilter) {
        const url = `${this.API_DLV}/deliver/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter);
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // deliverSearch

    async saveDeliver(deliverId: number, deliver: any) {
        const url = `${this.API_DLV}/deliver/save/${deliverId}`;

        try {
            return await this.putReturnObject(url, deliver);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveDeliver

    async createDeliver(deliver: any) {
        const url = `${this.API_DLV}/deliver/create`;

        try {
            return await this.postReturnObject(url, deliver);
        } catch (error: any) {
            throw new Error(error);
        }
    }

    async deliverDeleteById(deliverId: number, comments: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_DLV}/deliver/delete/${deliverId}`;
        else
            url = `${this.API_DLV}/deliver/delete/${deliverId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // deliverDeleteById

    async advanceStatus(deliverId: number, status: any) {
        const url = `${this.API_DLV}/deliver/${deliverId}/advance_status/${status}`;

        try {
            return await this.putReturnObject(url, {});
        } catch (error: any) {
            throw new Error(error);
        }
    } // advanceStatus

    /* ITEM */

    async itemById(itemId: number) {
        const url = `${this.API_DLV}/deliver_item/${itemId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // itemById

    async itemList(deliverId: number, attributes: string[], pagination?: TPagination) {
        const url = `${this.API_DLV}/deliver_item/list/deliver/${deliverId}`;

        try {
            const resultObject = await this.postReturnObject(url, { attributes, pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // itemList

    async itemSearch(filter?: TFilter) {
        const url = `${this.API_DLV}/deliver_item/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // itemSearch

    async saveItem(deliverId: number, itemId: number, item: any) {
        const url = `${this.API_DLV}/deliver_item/save/${itemId}/deliver/${deliverId}`;

        try {
            return await this.putReturnObject(url, item);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveItem

    async createItem(deliverId: number, item: any) {
        const url = `${this.API_DLV}/deliver_item/create/deliver/${deliverId}`;

        try {
            return await this.postReturnObject(url, item);
        } catch (error: any) {
            throw new Error(error);
        }
    }

    async itemDeleteById(itemId: number, comments: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_DLV}/deliver_item/delete/${itemId}`;
        else
            url = `${this.API_DLV}/deliver_item/delete/${itemId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // itemDeleteById

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new DlvService();
